import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://5f1f408039f7aaa81ce7ef47d3d54eb7@o116547.ingest.sentry.io/4506716186148864",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});